var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white"},[_c('ckeditor',{attrs:{"id":"ckeditorselector","editor":_vm.editor,"config":_vm.editorConfig},on:{"ready":_vm.onReady,"input":_vm.onEditorInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }